import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class CodeVerificationStore {

}

export enum CodeVerificationStoreKeys {

}
